export const data2 = {
  accounts: [
    {
      account_id: "vEX4kapmpVCg3zaowM7zFN9Z1Lov1GfvqzDLK",
      balances: {
        available: 100,
        current: 110,
        iso_currency_code: "USD",
        limit: null,
        unofficial_currency_code: null,
      },
      mask: "0000",
      name: "Plaid Checking",
      official_name: "Plaid Gold Standard 0% Interest Checking",
      subtype: "checking",
      type: "depository",
    },
    {
      account_id: "RW3r97RkRgu7ZbWmLjrbFqxoyrwAypsPalQ6l",
      balances: {
        available: null,
        current: 410,
        iso_currency_code: "USD",
        limit: 2000,
        unofficial_currency_code: null,
      },
      mask: "3333",
      name: "Plaid Credit Card",
      official_name: "Plaid Diamond 12.5% APR Interest Credit Card",
      subtype: "credit card",
      type: "credit",
    },
    {
      account_id: "6Rlz7AoxoWTp1jVwGE8jfRGda4ymaLf189REJ",
      balances: {
        available: null,
        current: 320.76,
        iso_currency_code: "USD",
        limit: null,
        unofficial_currency_code: null,
      },
      mask: "5555",
      name: "Plaid IRA",
      official_name: null,
      subtype: "ira",
      type: "investment",
    },
  ],
  item: {
    available_products: [
      "assets",
      "auth",
      "balance",
      "identity",
      "investments",
      "liabilities",
      "recurring_transactions",
    ],
    billed_products: ["transactions"],
    consent_expiration_time: null,
    error: null,
    institution_id: "ins_56",
    name: "Chase",
    item_id: "k7EG4VJLJ5IXnr5DRPertaMLn4lab7tLe6Bkp",
    optional_products: null,
    products: ["transactions"],
    update_type: "background",
    webhook: "",
  },
  request_id: "c6VDIQl6bOxh3VP",
};
